import React, { useState, useRef, useImperativeHandle } from 'react';
import { Spin, message } from 'antd';
import FormTags from '../FormTags/FormTags'; 
import FormSaveCancelToolbar from '../FormSaveCancelToolbar/FormSaveCancelToolbar'; 
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';

const TabTags = ( { form, isSavingCallback, ref } ) => {
    const formTagsRef = useRef( useRef );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ isModified, setIsModified ] = useState( false );
    const [ sync ] = useSyncObjectRelationships();
    const [ openConfirm, setOpenConfirm ] = useState( false );

    useImperativeHandle( ref, () => ( {
        isModified() {
            return isModified;
        },
        showSaveConfirm() {
            setOpenConfirm( true );
        }
    } ) );
 
    const handleSave = async () => {
        setIsSaving( true );
        isSavingCallback( true );
        setOpenConfirm( false ); 
         
        const syncData = courseFormUtils.getTagSyncValues( form );

        if ( syncData ) {
            try {
                await sync( { variables: { input: syncData } } );
                courseFormUtils.updateTagValues( form, syncData.relatedResourceIds );
                formTagsRef.current.reset();
                message.success( 'Course saved.' );
            } catch ( error ) { 
                console.error( 'Error saving!', error );  
                message.error( 'Error saving!' );   
            } 
        }

        setIsSaving( false );
        isSavingCallback( false );
    };

    const handleReset = () => {
        formTagsRef.current.reset();
        setOpenConfirm( false ); 
        isSavingCallback( false );
    };

    const handleModifiedChange = ( value ) => {
        setIsModified( value );
    };

    return (
        <div className="resources-tab tab-main-columns">
            <div className="left">
                <Spin spinning={ isSaving }>
                    <FormTags 
                        form={ form }
                        ref={ formTagsRef }
                        modifiedCallback={ handleModifiedChange } 
                    />
                </Spin>
            </div>

            <div className="right">
                <FormSaveCancelToolbar
                    form={ form } 
                    open={ openConfirm }
                    saving={ isSaving }
                    modified={ isModified }
                    saveCallback={ handleSave }
                    cancelCallback={ handleReset }
                />
            </div>
        </div>
    );
};

export default TabTags;
